import BaseContainer from "@/components/baseContainer";
import AccountWithdrawForm from '@/components/form/accountWithdrawForm';
import { linkToIframe } from '@/utiils';
import {  WP_URL } from '@/config';

const WithdrawPage = () => {
  const onComplete = () => {
    // トークン破棄してトップへ
    localStorage.removeItem('token');
    document.cookie = 'ak_logged_in=; Path=/; Max-Age=0; Secure; SameSite=Lax';
    // window.location.href = 'withdraw_complete'; // 完了ページ（任意）
    linkToIframe('', { isIframeUrl: `${WP_URL}` });
  };

  return (
    <div className="my-16">
      <BaseContainer>
        <AccountWithdrawForm onComplete={onComplete} />
      </BaseContainer>
    </div>
  );
};

export default WithdrawPage;
